// @flow
import { createSelector } from 'reselect';
import { fetchBidderBiddingAll } from '../api/biddingInfo';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import type { GlobalState } from '../rootReducer';
import { LOG_OUT_BIDDER } from './actions';
import ms from 'ms';

/* Action Types */
export const LOAD_BIDDER_BIDDING_ALL_FAIL = 'la/domain/bidderBiddingAll/LOAD_FAIL';
export const LOAD_BIDDER_BIDDING_ALL_REQUEST = 'la/domain/bidderBiddingAll/LOAD_REQUEST';
export const LOAD_BIDDER_BIDDING_ALL_SUCCESS = 'la/domain/bidderBiddingAll/LOAD_SUCCESS';

const REDUX_STORE_TIME = ms('15m');

/* reducer */
const DEFAULT_STATE = {
    loaded: 0,
    loading: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    let loaded;
    let loading;

    switch (action.type) {
        case LOAD_BIDDER_BIDDING_ALL_FAIL:
            return {
                ...state,
                loading: false,
            };
        case LOAD_BIDDER_BIDDING_ALL_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case LOAD_BIDDER_BIDDING_ALL_SUCCESS:
            loaded = action.meta.actionTime;
            loading = false;

            return {
                ...state,
                loaded,
                loading,
            };
        case LOG_OUT_BIDDER:
            return { ...DEFAULT_STATE };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.bidderBiddingInfoAll;

const loadedSelector = createSelector(stateSelector, state => state.loaded);

const loadingSelector = createSelector(stateSelector, state => state.loading);

const shouldFetch = createSelector([loadedSelector, loadingSelector], (loaded, loading) => {
    const time = Date.now();
    const diff = time - loaded;
    if (diff < REDUX_STORE_TIME) return false;
    return !loading;
});

/* ACTION CREATORS */
const doFetch = async ({ dispatch, getState }) => {
    const state = getState();
    try {
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        dispatch({
            meta: { actionTime: Date.now() },
            type: LOAD_BIDDER_BIDDING_ALL_REQUEST,
        });
        const response = await fetchBidderBiddingAll({ authToken, deployment });
        dispatch({
            meta: { actionTime: Date.now() },
            payload: response.data,
            type: LOAD_BIDDER_BIDDING_ALL_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            meta: { actionTime: Date.now() },
            payload: error,
            type: LOAD_BIDDER_BIDDING_ALL_FAIL,
        });
    }
};

export const fetchAllBidderBiddingIfNeeded = () => async (dispatch: Function, getState: Function) => {
    const state = getState();
    const authToken = getAuthToken(state);
    if (authToken && shouldFetch(state)) {
        return doFetch({ dispatch, getState });
    }
    return Promise.resolve({});
};
